module.exports = __webpack_public_path__ + "img/selected3-min.631662aa.png";